import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './styles/tokens.css';
import './styles/shell.css';
import './styles/components.css';
import './styles/kiosk.css';
import { ThemeProvider } from './theme';
import App from './App';

const LANG_STORAGE_KEY = 'nexus_lang';
const SUPPORTED_LANGS = ['es', 'ca', 'en'];
const DEFAULT_LANG = 'es';

function getCurrentLang() {
    try {
        const stored = localStorage.getItem(LANG_STORAGE_KEY);
        if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
    } catch (e) { }
    const nav = (navigator.language || '').slice(0, 2).toLowerCase();
    return SUPPORTED_LANGS.includes(nav) ? nav : DEFAULT_LANG;
}

const _originalFetch = window.fetch;
window.fetch = function(input, init) {
    init = init || {};
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('/api/') !== -1) {
        try {
            const headers = new Headers(init.headers || {});
            if (!headers.has('Accept-Language')) {
                headers.set('Accept-Language', getCurrentLang());
            }
            init.headers = headers;
        } catch (e) {
            const existingHeaders = init.headers || {};
            if (!existingHeaders['Accept-Language'] && !existingHeaders['accept-language']) {
                init.headers = {
                    ...existingHeaders,
                    'Accept-Language': getCurrentLang(),
                };
            }
        }
    }
    return _originalFetch.call(this, input, init);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>
);
